(function () {
  'use strict';

  var component = {
    template:'<div hl-sticky><ul class="hq-lighting-wizard-bar"><li ui-sref="room" ui-sref-active="hq-lighting-active" ng-keyup="$event.keyCode == 13 ? $ctrl.goto(\'room\') : null" tabindex="0"><span class="visuallyhidden">{{\'STEP\' | translate}} 1 :</span> <span translate="ROOM"></span></li><li tabindex="{{$ctrl.steps[\'fixture\'] && 0}}" ui-sref="fixture" ui-sref-active="hq-lighting-active" ng-keyup="$event.keyCode == 13 ? $ctrl.goto(\'fixture\') : null" aria-hidden="{{!$ctrl.steps[\'fixture\']}}"><span class="visuallyhidden">{{\'STEP\' | translate}} 2 :</span> <span translate="FIXTURE"></span></li><li tabindex="{{$ctrl.steps[\'base\'] && 0}}" ui-sref="base" ui-sref-active="hq-lighting-active" ng-keyup="$event.keyCode == 13 ? $ctrl.goto(\'base\') : null" aria-hidden="{{!$ctrl.steps[\'base\']}}"><span class="visuallyhidden">{{\'STEP\' | translate}} 3 :</span> <span translate="BASE"></span></li><li tabindex="{{$ctrl.steps[\'lumen\'] && 0}}" ui-sref="lumen" ui-sref-active="hq-lighting-active" aria-hidden="{{!$ctrl.steps[\'lumen\']}}" ng-keyup="$event.keyCode == 13 ? $ctrl.goto(\'lumen\') : null"><span class="visuallyhidden">{{\'STEP\' | translate}} 4 :</span> <span translate="LUMENS"></span></li><li tabindex="{{$ctrl.steps[\'kelvins\'] && 0}}" ui-sref="kelvins" ui-sref-active="hq-lighting-active" aria-hidden="{{!$ctrl.steps[\'kelvins\']}}" ng-keyup="$event.keyCode == 13 ? $ctrl.goto(\'kelvins\') : null"><span class="visuallyhidden">{{\'STEP\' | translate}} 5 :</span> <span translate="KELVINS"></span></li></ul></div>',
    controller: controller,
  };

  function controller(hqTLightingOptions, $transitions, $state) {
    'ngInject';

    var ctrl = this;

    ctrl.goto = function (sref) {
      $state.go(sref);
    };

    ctrl.steps = {};
    setState();

    $transitions.onSuccess({ to: '*' }, function () {
      setState();
    });

    function setState() {
      ctrl.steps = {
        location: false,
        room: true, // TODO Check for location selection
        fixture: hqTLightingOptions.roomSelection !== null,
        base: hqTLightingOptions.fixtureSelection !== null,
        lumen: hqTLightingOptions.baseSelection !== null,
        kelvins: hqTLightingOptions.lumenSelection !== null,
      };
    }
  }

  angular
    .module('hq.tools.lighting')
    .component('hqToolsLightingWizardBar', component);
}());
